import {
    FETCH_LOYALTY_PROGRAM_BENEFITS,
    SAVE_BENEFIT,
    DELETE_BENEFIT,
    ISSUE_BENEFIT,
    UPDATE_ISSUED_BENEFIT,
    CLOSE_ISSUED_BENEFIT
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_LOYALTY_PROGRAM_BENEFITS:
            return action.payload;
        case SAVE_BENEFIT:
            if (action.meta && action.meta.benefitId) {
                return state.map(benefit => benefit.id === action.meta.benefitId ? action.payload : benefit);
            }
            return state.concat([action.payload]);
        case DELETE_BENEFIT:
            return state.filter(benefit => benefit.id !== action.meta.benefitId);
        case ISSUE_BENEFIT:
            return state.map(ben => {
                const benefit = {...ben};
                if(benefit.id === action.meta.benefitId) {
                    benefit.issues.push(action.payload);
                }
                return benefit;
            });
        case CLOSE_ISSUED_BENEFIT:
        case UPDATE_ISSUED_BENEFIT:
            return state.map(ben => {
                const benefit = {...ben};
                if(benefit.id === action.meta.benefitId) {
                    benefit.issues = benefit.issues.map(issue => {
                        if(action.meta.issueId === issue.id) {
                            return action.payload;
                        }
                        return issue;
                    });
                }
                return benefit;
            });
        default:
            return state;
    }
};